export default __webpack_public_path__ + "static/media/ic_buy_flp.03f302d8.svg";